import { useDrawer } from '@app/src/components/Drawer/DrawerContext'
import DrawerViewInvitation from '@app/src/components/Drawer/Views/DrawerViewInvitation'
import type { DrawerViewUserProps } from '@app/src/components/Drawer/Views/DrawerViewUser'
import DrawerViewUser from '@app/src/components/Drawer/Views/DrawerViewUser'
import type { Invitation, User } from '@app/src/types/resourceExplorer'
import { ResourceTypes } from '@app/src/wf-constants'
import { Typography } from '@mui/material'
import React from 'react'
import ParentCellOrFragment from './ParentCellOrFragment'
import UserInline from '@app/src/components/Ui/UserInline'

export type UserCellProps = {
  user?: User | Invitation
  drawer?: boolean
  disableCell?: boolean
  isDisabled?: boolean
} & Omit<DrawerViewUserProps, 'user'>

const isUserType = (user: UserCellProps['user']): user is User => user?.type.toLowerCase() === ResourceTypes.User

const UserCell: React.FC<UserCellProps> = ({ user, drawer, disableCell, isDisabled, ...props }) => {
  const { openDrawer } = useDrawer()

  if (!user) {
    return (
      <ParentCellOrFragment disableCell={disableCell}>
        <Typography variant="body1">-</Typography>
      </ParentCellOrFragment>
    )
  }

  return (
    <ParentCellOrFragment disableCell={disableCell}>
      <UserInline
        name={user.name}
        isDisabled={isDisabled}
        hoverUnderline={!!drawer}
        fullWidth
        onClick={
          drawer
            ? () =>
                openDrawer(
                  isUserType(user) ? (
                    <DrawerViewUser user={user} {...props} />
                  ) : (
                    <DrawerViewInvitation invitation={user} />
                  ),
                )
            : undefined
        }
        dataTestId="user-name"
      />
    </ParentCellOrFragment>
  )
}

export default UserCell
